<ion-content class="ion-no-padding">
  <form class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Visa Checklist ({{countryId}})</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" (click)="sendvisachecklist($event)">
            Send
          </ion-button>

          <ion-button *ngIf="organizationId === 'ORG100000'" class="filled-blue-btn" (click)="openEditVisaInformation()">
            Edit
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content" #sendthishtmldivtag>
      <div *ngIf="visaInformation">

        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">General Information</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.countryInfo">
            <div class="form-sub-heading-container">
              <p class="sub-heading">Details</p>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Country Name</label>
                  <div>
                    <p class="value">{{visaInformation.countryInfo.country}}</p>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Currency</label>
                  <div>
                    <p class="value">{{visaInformation.countryInfo.currency}}</p>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Time Zone</label>
                  <div>
                    <p class="value">{{visaInformation.countryInfo.timeZone}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-sub-heading-container">
              <p class="sub-heading">Embassy Details</p>
            </div>
            <div class="row">
              <!-- <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Address</label>
                  <div>
                    <p class="value">{{visaInformation.countryInfo.address || '--'}}</p>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Phone Number</label>
                  <div>
                    <p class="value">{{visaInformation.countryInfo?.phone?.countryCode}} {{visaInformation.countryInfo?.phone?.phone}}</p>
                  </div>
                </div>
              </div> -->

              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Email ID</label>
                  <div>
                    <p class="value">{{visaInformation.countryInfo.email}}</p>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="input-container">
                  <label for="" class="label">Website</label>
                    <div>
                    <p class="value">
                      <a *ngIf="visaInformation.countryInfo.website"
                       [href]="visaInformation.countryInfo.website.startsWith('http') ? visaInformation.countryInfo.website : 'https://' + visaInformation.countryInfo.website"
                       target="_blank" rel="noopener noreferrer">
                      {{visaInformation.countryInfo.website}}
                      </a>
                      <span *ngIf="!visaInformation.countryInfo.website">--</span>
                    </p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mandatory Documents -->
        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Mandatory Documents</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.mandatoryDocuments">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Important Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.mandatoryDocuments.data && visaInformation.mandatoryDocuments.data.length">
                <div class="document-item-container" *ngFor="let item of visaInformation.mandatoryDocuments.data">
                  <div class="doc-label-container">
                    <div class="input-container">
                      <div>
                        <i class="point-style-arrow"></i>
                        <p class="document-label">{{item.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="input-notes-container">
                    <div class="input-container">
                      <div>
                        <p class="document-value">{{item.note}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="py-2" *ngIf="!visaInformation.mandatoryDocuments.data || visaInformation.mandatoryDocuments.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Documents based on visa type -->
        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Documents Based On Visa Type & Applicant Type</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.documentsBasedOnVisa">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Important Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.documentsBasedOnVisa.data && visaInformation.documentsBasedOnVisa.data.length">
                <ng-container *ngFor="let item of visaInformation.documentsBasedOnVisa.data">
                  <div class="document-item-container" >
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div>
                          <i class="point-style-arrow"></i>
                          <p class="document-label">{{item.name}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div>
                          <p class="document-value">{{item.note}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="border border-1 rounded p-1 mb-1 checkbox-container-grid">
                      <div>
                        <div class="input-container">
                          <label for="" class="label">Visa Type</label>
                        </div>
                      </div>
                      <div>
                        <!-- <div class=" visa-type-item" >
                          <div>
                            <label for="" class="checkbox-label">{{item.visaTypes?.join('  |  ')}}</label>
                          </div>
                        </div> -->
                        <div class="visa-type-item" >
                          <div class="visa-type-container">
                            <div *ngFor="let type of item.visaTypes" class="visa-type-box">
                              {{ type }}
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                    <div class="border border-1 rounded p-1 mb-1 checkbox-container-grid">
                      <div>
                        <div class="input-container">
                          <label for="" class="label">Applicant Type</label>
                        </div>
                      </div>
                      <div>
                        <div class=" visa-type-item" >
                          <div class="visa-type-container">
                            <div *ngFor="let type of item.applicantTypes" class="visa-type-box">
                              {{ type }}
                            </div>
                          </div>
                          <!-- <div>
                            <label for="" class="checkbox-label">{{item.applicantTypes?.join('  |  ')}}</label>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dashed-line my-2"></div>
                </ng-container>
              </div>

              <div class="py-2" *ngIf="!visaInformation.documentsBasedOnVisa.data || visaInformation.documentsBasedOnVisa.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Other documents -->

        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Other Documents</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.otherDocuments">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Important Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.otherDocuments.data && visaInformation.otherDocuments.data.length">
                <div class="document-item-container" *ngFor="let item of visaInformation.otherDocuments.data">
                  <div class="doc-label-container">
                    <div class="input-container">
                      <div>
                        <i class="point-style-arrow"></i>
                        <p class="document-label">{{item.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="input-notes-container">
                    <div class="input-container">
                      <div>
                        <p class="document-value">{{item.note}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="py-2" *ngIf="!visaInformation.otherDocuments.data || visaInformation.otherDocuments.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Key points to know -->

        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Key Points To Know</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.keyPoints">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.keyPoints.data && visaInformation.keyPoints.data.length">
                <div class="document-item-container" *ngFor="let item of visaInformation.keyPoints.data">
                  <div class="doc-label-container">
                    <div class="input-container">
                      <div>
                        <i class="point-style-arrow"></i>
                        <p class="document-label">{{item.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="input-notes-container">
                    <div class="input-container">
                      <div>
                        <p class="document-value">{{item.note}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pb-2" *ngIf="!visaInformation.keyPoints.data || visaInformation.keyPoints.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Restricted itesm -->

        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Restricted Items</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.restrictedItems">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.restrictedItems.data && visaInformation.restrictedItems.data.length">
                <div class="document-item-container" *ngFor="let item of visaInformation.restrictedItems.data">
                  <div class="doc-label-container">
                    <div class="input-container">
                      <div>
                        <i class="point-style-arrow"></i>
                        <p class="document-label">{{item.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="input-notes-container">
                    <div class="input-container">
                      <div>
                        <p class="document-value">{{item.note}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pb-2" *ngIf="!visaInformation.restrictedItems.data || visaInformation.restrictedItems.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Important notes -->

        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Important Notes</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.importantNotes">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.importantNotes.data && visaInformation.importantNotes.data.length">
                <div class="document-item-container" *ngFor="let item of visaInformation.importantNotes.data">
                  <div class="doc-label-container">
                    <div class="input-container">
                      <div>
                        <i class="point-style-arrow"></i>
                        <p class="document-label">{{item.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="input-notes-container">
                    <div class="input-container">
                      <div>
                        <p class="document-value">{{item.note}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pb-2" *ngIf="!visaInformation.importantNotes.data || visaInformation.importantNotes.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Details about stay -->

        <div>
          <div class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Details About Stay</div>
        </div>
        <div class="ion-padding-horizontal py-1">
          <div class="bg-blue-container" *ngIf="visaInformation.detailsAboutStay">
            <div>
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div *ngIf="visaInformation.detailsAboutStay.data && visaInformation.detailsAboutStay.data.length">
                <div class="document-item-container" *ngFor="let item of visaInformation.detailsAboutStay.data">
                  <div class="doc-label-container">
                    <div class="input-container">
                      <div>
                        <i class="point-style-arrow"></i>
                        <p class="document-label">{{item.name}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="input-notes-container">
                    <div class="input-container">
                      <div>
                        <p class="document-value">{{item.note}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pb-2" *ngIf="!visaInformation.detailsAboutStay.data || visaInformation.detailsAboutStay.data.length === 0">
                <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

  </form>
</ion-content>



<!-- ---------------------- -->